import styled from 'styled-components'

export const StyledPrivacyPolicyWrapper = styled.div`
  padding: 25px 0;
  text-align: justify;

  h4 {
    font-family: KreonBold;
  }
`
